import { render, staticRenderFns } from "./ColorThemeDialog.vue?vue&type=template&id=596d54e9&scoped=true"
import script from "./ColorThemeDialog.vue?vue&type=script&lang=ts"
export * from "./ColorThemeDialog.vue?vue&type=script&lang=ts"
import style0 from "./ColorThemeDialog.vue?vue&type=style&index=0&id=596d54e9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596d54e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('596d54e9')) {
      api.createRecord('596d54e9', component.options)
    } else {
      api.reload('596d54e9', component.options)
    }
    module.hot.accept("./ColorThemeDialog.vue?vue&type=template&id=596d54e9&scoped=true", function () {
      api.rerender('596d54e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/ColorThemeDialog.vue"
export default component.exports